module.exports = __webpack_public_path__ + "static/media/ic_home_white_36px.5a5d43fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ic_home_white_36px.svg
// module id = 249
// module chunks = 0